import { HomeData, HomeDetails } from '@/types/homes'
import Paths from '@/config/paths'
import { SEOProps } from '@/types/seo'
import { homeAddressStr } from '@/helpers/homes'

const path = Paths.Home9209seminole156.loc

export const data: HomeData = {
  mlNumber: 'TB8386301', 
  status: 'Sold',
  address: '9209 Seminole blvd #156',
  city: 'Seminole',
  zip: '33772',
  legalSubdivisionName: 'TOWNHOMES OF LAKE SEMINOLE',
  subdivisionCondoName: 'TOWNHOMES OF LAKE SEMINOLE',
  heatedArea: '1335',
  currentPrice: '$299,999',
  beds: 3,
  fullBaths: 2,
  halfBaths: 1,
  yearBuilt: 1980,
  pool: 'Community',
  propertyStyle: 'Townhouse',
  tax: '', // Placeholder (not provided)
  cdom: 0, // Placeholder (not provided)
  adom: 0, // Placeholder (not provided)
  daysToContract: null,
  soldTerms: null,
  closeDate: null,
  lpPerSqFt: '228.46',
  spPerSqFt: '228.46',
  spPerLp: null,
  listOffice: "",
  listAgent: 'Edith Austin', // Placeholder
  listAgentId: '', // Placeholder
  sellingOfficeId: null,
  lscListSide: '', // Placeholder
  listOfficePrimaryBoardId: '', // Placeholder
};

export const details: HomeDetails = {
  path,
  sellingPoint: "townhome for sale in Townhomes of Lake Seminole, Seminole, FL. Featuring a remodeled kitchen, screened lanai, spacious primary suite, and access to a community pool, tennis courts, and private fishing pier. Just minutes from Gulf Beaches and Seminole City Center! Don't miss this move-in ready gem in a serene waterfront community.",
  thumbnailImgStr: '/images/homes/thumbnail/9209-seminole-tn.jpg',
  info: 'Check out this home today, call me to schedule a viewing (805) 765-1625',
}

export const seo: SEOProps = {
  title: `View home ${homeAddressStr(data)}`,
  description:
    "Move-in ready 3 bed, 2.5 bath townhome in Townhomes of Lake Seminole, Seminole, FL. Features include a remodeled kitchen, screened lanai, spacious primary suite, and community amenities like pool, tennis courts, and private dock. Minutes from Gulf Beaches and top-rated local attractions.",
  type: 'article',
  pagePath: path
}
